import { calculateTotalDays } from "../../../../../utils/calculateTotalDays";
import { useTranslation } from "react-i18next";

export const RoomDetails = (props) => {
  const { t } = useTranslation();
  const { booking, branding, extraBedPrice } = props;
  const roomDetails =
    booking.rooms && booking.rooms.length > 0 ? (
      booking.rooms.map((room, index) => (
        <div key={index} className="wrapper">
          <div
            className="padding-10"
            style={{
              backgroundColor: branding.headingColor,
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              fontFamily: branding.headingFont,
            }}
          >
            Room {index + 1}: {room.room || "N/A"} -{" "}
            {room.ratePlanName || "N/A"}
          </div>
          <table className="table-wrapper">
            <tbody>
              <tr>
                <th className="custom-room-details">
                  {t("booking.confirmation.room_detail.number_of_rooms")}
                </th>
                <td className="custom-room-details">
                  {room.numberOfRooms || "N/A"}
                </td>
              </tr>
              <tr>
                <th className="custom-room-details">
                  {t("booking.confirmation.room_detail.rate_plan")}
                </th>
                <td className="custom-room-details">
                  {room.ratePlanName || "N/A"}
                </td>
              </tr>
              <tr>
                <th className="custom-room-details">
                  {t("booking.confirmation.room_detail.rate")}
                </th>
                <td
                  className="custom-room-details"
                  style={{
                    color: branding.priceTagColor,
                    fontWeight: "bold",
                  }}
                >
                  {room.ratePlanRate
                    ? `${room.ratePlanRate.toLocaleString()} VND ${
                        room.promoCode
                          ? `(includes ${room.promoCode} discount)`
                          : ""
                      }`
                    : "0 VND"}
                </td>
              </tr>
              <tr>
                <th className="custom-room-details">
                  {t("booking.confirmation.room_detail.adults")}
                </th>
                <td className="custom-room-details">{room.adults || 0}</td>
              </tr>
              <tr>
                <th className="custom-room-details">
                  {t("booking.confirmation.room_detail.children")}
                </th>
                <td className="custom-room-details">{room.children || 0}</td>
              </tr>
              <tr>
                <th className="custom-room-details">
                  {t("booking.confirmation.room_detail.extra_bed")}
                </th>
                <td className="custom-room-details">
                  {room.extraBed &&
                  Object.values(room.extraBed).some((value) => value)
                    ? `YES (${extraBedPrice?.toLocaleString()} VND per night)`
                    : "NO"}
                  {room.extraBed &&
                    Object.values(room.extraBed).some((value) => value) && (
                      <p>
                        <strong>
                          {t(
                            "booking.confirmation.room_detail.total_extra_bed_price"
                          )}
                          :
                        </strong>
                        {(
                          extraBedPrice *
                          calculateTotalDays(booking.fromdate, booking.todate)
                        ).toLocaleString()}
                        VND
                      </p>
                    )}
                </td>
              </tr>
              <tr>
                <th className="padding-10">
                  {t("booking.confirmation.room_detail.cancellation_policy")}
                </th>
                <td className="padding-10">
                  {room.cancellationPolicy || "Flexible"}
                </td>
              </tr>
            </tbody>
          </table>

          {Array.isArray(room.rateBreakdown) &&
          room.rateBreakdown.length > 0 ? (
            <div style={{ marginTop: "20px" }}>
              <h4 style={{ marginBottom: "10px", fontWeight: "bold" }}>
                {t("booking.confirmation.rate_breakdown.title")}
              </h4>
              <table
                className="table-wrapper"
                style={{
                  textAlign: "center",
                  border: "1px solid #ddd",
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#f0f0f0",
                      fontWeight: "bold",
                    }}
                  >
                    <th className="custom-rate-breakdown">
                      {t("booking.confirmation.rate_breakdown.date")}
                    </th>
                    <th className="custom-rate-breakdown">
                      {t("booking.confirmation.rate_breakdown.original_rate")}{" "}
                      (VND)
                    </th>
                    <th className="custom-rate-breakdown">
                      {t("booking.confirmation.rate_breakdown.promotion")}
                    </th>
                    <th className="custom-rate-breakdown">
                      {t(
                        "booking.confirmation.rate_breakdown.promotion_discount"
                      )}
                    </th>
                    <th className="custom-rate-breakdown">
                      {t("booking.confirmation.rate_breakdown.promo_code")}
                    </th>
                    <th className="custom-rate-breakdown">
                      {t("booking.confirmation.rate_breakdown.final_rate")}{" "}
                      (VND)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {room.rateBreakdown.map((rate, i) => (
                    <tr key={i}>
                      <td className="custom-rate-breakdown">
                        {rate.date || "N/A"}
                      </td>
                      <td
                        className="custom-rate-breakdown"
                        style={{
                          color: "#000",
                        }}
                      >
                        {rate.originalRate
                          ? `${rate.originalRate.toLocaleString()} VND`
                          : "0 VND"}
                      </td>
                      <td
                        className="custom-rate-breakdown"
                        style={{
                          color: "#666",
                          fontStyle: "italic",
                        }}
                      >
                        {rate.promotion || "No Promotion"}
                      </td>
                      <td
                        className="custom-rate-breakdown"
                        style={{
                          color: "#ff4d4f",
                        }}
                      >
                        {rate.promotionDiscount
                          ? `-${rate.promotionDiscount}%`
                          : "0%"}
                      </td>
                      <td
                        className="custom-rate-breakdown"
                        style={{
                          color: "#ff7f50",
                        }}
                      >
                        {room.promoCode || "None"}
                      </td>
                      <td
                        className="custom-rate-breakdown"
                        style={{
                          color: branding.priceTagColor,
                          fontWeight: "bold",
                        }}
                      >
                        {rate.finalRate
                          ? `${rate.finalRate.toLocaleString()} VND`
                          : `${rate.originalRate.toLocaleString()} VND`}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p
              style={{
                marginTop: "10px",
                fontStyle: "italic",
                color: "#888",
              }}
            >
              {t("booking.confirmation.rate_breakdown.no_data")}
            </p>
          )}
        </div>
      ))
    ) : (
      <p style={{ marginTop: "20px", fontWeight: "bold" }}>
        {t("booking.confirmation.room_detail.no_data")}
      </p>
    );
  return roomDetails;
};
